/// <reference path="../_all.ts" />

module user {

  LoginFormDirective.$inject = ['userService', '$window', 'debounce', 'pageMetaService', '$mdDialog', '$timeout', '$location'];
  export function LoginFormDirective(
    userService: user.UserService,
    $window: ng.IWindowService,
    debounce: navigation.IDebounceService,
    pageMetaService: navigation.IPageMetaService,
    $mdDialog: ng.material.IDialogService,
    $timeout: ng.ITimeoutService,
    $location : ng.ILocationService
  ): ng.IDirective {
    return {
      restrict: 'AE',
      scope: true,
      templateUrl: 'user/LoginFormDirective',
      link: function (scope: ILoginFormScope, element: ng.IAugmentedJQuery, attr: ng.IAttributes) {
        
        scope.meta = pageMetaService.getPageMeta;

        scope.$watch('$viewContentLoaded', function(){
          $timeout(function() {
            $(element).find('input[name=email]').select(); 
          },0);
        });

        var redirect = (returnUrl) => {
          if (returnUrl) {
            $window.location.href = returnUrl;
          } else {
            $window.location.reload();
          }
        }

        if (!scope.setProgress) throw "ParentController needs function setProgress."

        scope.setProgress(false);
        scope.doLogin = function() {
          
          var returnUrl = $location.search()['ReturnUrl'];

          scope.loginform.password.$setValidity('wrong', true); 
          if (scope.loginform.$invalid) return;

          scope.setProgress(true);
          userService.login(scope.login, returnUrl).then((response : { data : { Success : boolean, ReturnUrl: string}}) => {
            if (response.data.Success) {
              scope.loginform.password.$setValidity('wrong', true); 
              redirect(response.data.ReturnUrl);
              //scope.requestOnGoing = false;
            } else {
              scope.login.password = null;
              scope.loginform.password.$setValidity('wrong', false); 
              $timeout(function() {
                $(element).find('input[name=password]').focus(); 
              },0);
              scope.setProgress(false);           
            }
          });
        };

        scope.openResetPasswordModal = function (ev: MouseEvent) {
          $mdDialog.show(<ng.material.IDialogOptions>{
            controller: 'ForgotPasswordCtrl',
            templateUrl: 'user/ForgotPasswordDirective',
            parent: angular.element(document.body),
            bindToController: true,
            targetEvent: ev,
            clickOutsideToClose: true,
            fullscreen: true, // Only for -xs, -sm breakpoints.
            locals: {
              parentScope: scope
            },
          })
            .then(function () {
              console.log('Modal closed at: ' + new Date());
            }, function () {
              console.log('Modal canceled at: ' + new Date());
            });
        };

        scope.intranetLogin = function(ev: MouseEvent) {
          var returnUrl = $location.search()['ReturnUrl'];
          userService.intranetLogin(returnUrl).then((response : { data :  { Success : boolean, ReturnUrl: string} }) => { 
            if(response.data.Success) {
              redirect(response.data.ReturnUrl); 
            } else {
              alert("Intranet login fehlgeschlagen (success = false), bitte mit AGIT in Verbindung treten");
            }
          }, () => {
            alert("Intranet login fehlgeschlagen (reject), bitte mit AGIT in Verbindung treten");
          });
        };

      }
    }
  }

}